import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var ArrowSyncCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm3.27-11.25H14a.75.75 0 0 0 0 1.5h2.75c.41 0 .75-.34.75-.75V8.25a.75.75 0 0 0-1.5 0V9a5 5 0 0 0-7.83-.23.75.75 0 0 0 1.16.96 3.5 3.5 0 0 1 5.94 1.02zm-7.27 5V15a5 5 0 0 0 7.82.24.75.75 0 1 0-1.14-.97 3.51 3.51 0 0 1-5.84-.77H10a.75.75 0 0 0 0-1.5H7.25a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0z"
  }));
});
ArrowSyncCircle.displayName = 'ArrowSyncCircle';
export var ArrowSyncCircleDimensions = {
  height: 24,
  width: 24
};